import { makeStyles } from "@mui/styles";
import theme from "src/theme";

export const useStyles = makeStyles({
    playerWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        overflow: "visible",
        [theme.breakpoints.down("lg")]: {
            overflow: "initial",
            containerType: "size",
            justifyContent: "flex-start",
            height: "75%",
            gridGap: "4px",
        },
        [theme.breakpoints.down("sm")]: {
            height: "75%",
            justifyContent: "flex-start",
            gap: 10,
        },
    },

    playerAvatar: {
        width: 40,
        height: 40,
        marginRight: 4,
        minWidth: 40,
        aspectRatio: "1 / 1",
        [theme.breakpoints.down("lg")]: {
            width: 32,  
            height: 32,
            minWidth: 32,
        },
        [theme.breakpoints.down("md")]: {
            width: 28, 
            height: 28,
            minWidth: 28,
        },
        [theme.breakpoints.down("sm")]: {
            width: 24, 
            height: 24,
            minWidth: 24,
            marginRight: 0,
        },
    },


    avatarContainer: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    starsOverlay: {
        position: "absolute",
        left: "50%",
        top: "50%",
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 10,
    },

    placeholderAvatar: {
        height: "inherit",
        aspectRatio: "1 / 1",
        borderRadius: "50%",
    },

    nicknameContainer: {
        display: "flex",
        alignItems: "center",
        overflow: "hidden", 
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "110px",
        [theme.breakpoints.down("lg")]: {
            maxWidth: "100px",
        },
        [theme.breakpoints.down("md")]: {
            maxWidth: "80px",
        },
        [theme.breakpoints.down("sm")]: {
            maxWidth: "80px",
        },
    },

    playerNickname: {
        fontSize: 20,
        fontWeight: 400,
        lineHeight: "24px",
        color: "#F5F5F5CC",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        [theme.breakpoints.down("lg")]: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontSize: 18,
            fontWeight: 500,
            lineHeight: "20px",
        },
        [theme.breakpoints.down("md")]: {
            fontSize: 15,
            fontWeight: 500,
            lineHeight: "17px",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: 12,
            fontWeight: 500,
            lineHeight: "14px",
            width: '100%',
        },
    },
});
